import { useContextTranslation } from '@core/i18n';
import { useStore } from '@core/widgets/store';
import { paramsLangSelector } from '@core/widgets/store/selectors';
/**
 *
 */
export const useGetLiveStreamingDateTime = ({ startAt, }) => {
    const { t } = useContextTranslation();
    const locale = useStore(paramsLangSelector);
    if (!startAt) {
        return {
            liveStreamingDate: null,
            liveStreamingTime: null,
            liveStreamingMeridiem: null,
        };
    }
    const time = new Date(startAt);
    const formatTime = time.toLocaleString(locale, {
        hour: 'numeric',
        minute: 'numeric',
    });
    const isMeridiem = ['AM', 'PM'].some((text) => formatTime.includes(text));
    const timeDisplay = getTimeDisplay(time, t, locale);
    return {
        liveStreamingDate: timeDisplay,
        liveStreamingTime: isMeridiem
            ? `${formatTime.slice(0, formatTime.length - 3)}`
            : formatTime,
        liveStreamingMeridiem: isMeridiem
            ? `${formatTime.substring(formatTime.length - 2, formatTime.length)}`
            : '',
    };
};
function getTimeDisplay(streamTime, t, locale) {
    const today = new Date();
    if (isSameDate(streamTime, today)) {
        return t('Today');
    }
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    if (isSameDate(streamTime, tomorrow)) {
        return t('Tomorrow');
    }
    return streamTime.toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
    });
}
function isSameDate(date1, date2) {
    return (date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear());
}
